
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import 'vue';
import get from 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import PendoButton from './pendo-button.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import PendoTooltip from './pendo-tooltip.js';
import './pendo-divider.js';
import 'lodash/isNumber';
import './table-auto-height-mixin.js';
import 'popper.js';
import uuid from 'uuid';
import 'vue-resize';
import 'lodash/clamp';
import './picker-popover-mixin.js';
import 'lodash/debounce';
import './emitter-mixin.js';
import 'element-ui/lib/dialog';
import 'resize-observer-polyfill';
import PendoModal from './pendo-modal.js';
import 'lodash/isFunction';
import './multiselect-helper-mixin.js';
import './pendo-multiselect-props.js';
import './pendo-multiselect-core.js';
import './pendo-multiselect-input.js';
import './pendo-multiselect-option.js';
import 'compute-scroll-into-view';
import './pendo-multiselect-options.js';
import './pendo-multiselect-trigger.js';
import './pendo-multiselect-value.js';
import PendoMultiselect from './pendo-multiselect.js';
import 'lodash/cloneDeep';
import '@shopify/draggable/lib/es5/sortable.js';
import './pendo-draggable.js';
import PendoColumnReorder from './pendo-column-reorder.js';
import groupBy from 'lodash/groupBy';
import PendoIconOption from './pendo-icon-option.js';
import startCase from 'lodash/startCase';
import PendoGuideStatusOption from './pendo-guide-status-option.js';
import some from 'lodash/some';
import PendoGroupOption from './pendo-group-option.js';

function isProductOption(option) {
  return ['page', 'feature', 'poll', 'guide'].includes(option.type);
}
function getOptionIconType(option) {
  if (isProductOption(option)) {
    return option.type;
  }

  return option.kind;
}
function getResourceOptions(resources, field) {
  return resources.filter(resource => {
    if (field === 'guideId') {
      const isResourceCenter = get(resource, 'attributes.resourceCenter') && resource.state !== 'public';
      return !isResourceCenter;
    }

    return true;
  }).map(resource => {
    if (field === 'guideId') {
      return _objectSpread({}, resource, {
        [field]: resource.id,
        guideStepId: get(resource, 'steps[0].id')
      });
    }

    return {
      [field]: resource.id,
      name: resource.name,
      group: {
        color: get(resource.group, 'color'),
        name: get(resource.group, 'name')
      }
    };
  });
}
function getFactOptionsForType(type) {
  return {
    feature: [{
      fact: 'eventCount',
      label: 'Number of Clicks'
    }, {
      fact: 'daysActive',
      label: 'Number of Days Active'
    }],
    page: [{
      fact: 'eventCount',
      label: 'Number of Page Views'
    }, {
      fact: 'daysActive',
      label: 'Number of Days Active'
    }, {
      fact: 'eventTime',
      label: 'Time On Page (minutes)'
    }],
    guide: [{
      fact: 'guideViews',
      label: 'Number of Guide Views'
    }]
  }[type];
}
function getAvailableColumns(options) {
  return options.map(option => {
    const iconType = getOptionIconType(option);
    return _objectSpread({}, option, {
      icon: {
        type: iconType,
        size: 14
      }
    });
  });
}
function groupOptionsByKind(options) {
  const groups = {
    productUsage: 'Product Usage',
    visitor: 'Visitor Data',
    account: 'Account Data',
    parentAccount: 'Parent Account Data'
  };
  const groupedOptions = groupBy(options, option => {
    if (isProductOption(option)) {
      return 'productUsage';
    }

    return option.kind;
  });
  return Object.keys(groups).reduce((acc, group) => {
    const options = groupedOptions[group];

    if (!options) {
      return acc;
    }

    acc.push({
      label: groups[group],
      id: group,
      options
    });
    return acc;
  }, []);
}
function getHasPolls(guide) {
  return some(guide.steps, step => step.pollIds && step.pollIds.length);
}

var script = {
  name: 'ResourceSelect',
  components: {
    PendoMultiselect,
    PendoGuideStatusOption,
    PendoGroupOption
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    field: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: 'Select Option'
    }
  },
  computed: {
    noResourcesFoundText() {
      const resourcesLabel = {
        page: 'pages',
        feature: 'features',
        trackType: 'track events',
        guide: 'guides',
        poll: 'polls'
      }[this.column.type];
      return `No ${resourcesLabel} found.`;
    }

  },
  methods: {
    onOptionSelect(option) {
      const selectedOption = {
        [this.field]: option[this.field]
      };

      if (this.field === 'guideId') {
        selectedOption.guideStepId = option.guideStepId;
      }

      this.$emit('select', _objectSpread({}, this.column, selectedOption));
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('pendo-multiselect', {
    staticClass: "resource-selector",
    class: _vm.field + "-select",
    attrs: {
      "value": _vm.value,
      "options": _vm.options,
      "extra-label-width": 60,
      "max-trigger-width": 286,
      "max-menu-width": 286,
      "allow-empty": false,
      "value-key": _vm.field,
      "loading": _vm.loading,
      "sort-by": "name",
      "hide-selected-options": "",
      "full-width": "",
      "label-key": "name",
      "placeholder": _vm.placeholder
    },
    on: {
      "select": _vm.onOptionSelect
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function (ref) {
        var toggleMenu = ref.toggleMenu;
        var model = ref.model;
        return [model[0] ? _c('div', {
          staticClass: "resource-selector__header"
        }, [_c('div', {
          staticClass: "resource-selector__selected-option"
        }, [model[0].group ? _c('pendo-group-option', {
          attrs: {
            "option": model[0]
          },
          on: {
            "click": toggleMenu
          }
        }) : _vm._e(), _vm._v(" "), model[0].state ? _c('pendo-guide-status-option', {
          attrs: {
            "tooltip": "",
            "option": model[0]
          },
          on: {
            "click": toggleMenu
          }
        }) : _vm._e()], 1)]) : _vm._e()];
      }
    }, {
      key: "noData",
      fn: function () {
        return [_vm._v("\n        " + _vm._s(_vm.noResourcesFoundText) + "\n    ")];
      },
      proxy: true
    }, {
      key: "selectedLabel",
      fn: function (ref) {
        var option = ref.option;
        return [!option.guideId ? _c('pendo-group-option', {
          attrs: {
            "option": option
          }
        }) : _vm._e(), _vm._v(" "), option.guideId ? _c('pendo-guide-status-option', {
          attrs: {
            "tooltip": "",
            "option": option
          }
        }) : _vm._e()];
      }
    }, {
      key: "option",
      fn: function (ref) {
        var option = ref.option;
        return [!option.guideId ? _c('pendo-group-option', {
          attrs: {
            "option": option
          }
        }) : _vm._e(), _vm._v(" "), option.guideId ? _c('pendo-guide-status-option', {
          attrs: {
            "tooltip": "",
            "option": option
          }
        }) : _vm._e()];
      }
    }])
  });
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "resource-selector.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var ResourceSelector = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

var script$1 = {
  name: 'PendoResourceColumnChooser',
  components: {
    ResourceSelector,
    PendoButton,
    PendoModal,
    PendoColumnReorder,
    PendoMultiselect,
    PendoIconOption,
    PendoIcon
  },
  directives: {
    PendoTooltip
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    featuresList: {
      type: Array,
      default: () => []
    },
    guidesList: {
      type: Array,
      default: () => []
    },
    pagesList: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    isLoadingResources: {
      type: Boolean,
      default: false
    },
    isLoadingMetadata: {
      type: Boolean,
      default: false
    },
    metadataList: {
      type: Array,
      default: () => []
    },
    allSelectedText: {
      type: String,
      default: 'All available columns selected.'
    },
    addButtonLabel: {
      type: String,
      default: 'Add Column'
    }
  },

  data() {
    return {
      localColumns: this.columns,
      toggleModal: false
    };
  },

  computed: {
    disableAddColumn() {
      return !this.availableOptions.length;
    },

    availableOptions() {
      const available = this.allColumnOptions.filter(option => {
        return isProductOption(option) || !this.selectedColumns.find(column => column.id === option.id);
      });
      return groupOptionsByKind(available);
    },

    pages() {
      return getResourceOptions(this.pagesList, 'pageId');
    },

    features() {
      return getResourceOptions(this.featuresList, 'featureId');
    },

    guides() {
      return getResourceOptions(this.guidesList, 'guideId');
    },

    polls() {
      const guidesWithPolls = this.guidesList.filter(guide => {
        const isResourceCenter = get(guide, 'attributes.resourceCenter') && guide.state !== 'public';
        return !isResourceCenter && getHasPolls(guide);
      });
      return getResourceOptions(guidesWithPolls, 'guideId');
    },

    availableColumns() {
      return groupOptionsByKind(this.allColumnOptions);
    },

    selectedColumns() {
      return this.localColumns.filter(column => column.allowReorder !== false).map((column, index) => {
        let id = column.id,
            name = column.name;
        const prop = column.prop;

        if (isProductOption(column)) {
          const type = column.type === 'poll' ? 'guide' : column.type;
          const resourceId = (column[`${type}Id`] || '').replace(/-/g, '_') || uuid();
          const fact = column.type === 'poll' ? column.pollId : column.fact;
          id = `${column.type}_${resourceId}_${fact}_${index}`;
        } else if (prop) {
          id = prop;
          name = column.label;
        }

        return _objectSpread({}, column, {
          id,
          name,
          disabled: column.immutable
        });
      });
    },

    allColumnOptions() {
      return getAvailableColumns(this.metadataList);
    }

  },
  methods: {
    addColumn() {
      if (this.disableAddColumn) {
        return;
      }

      const columns = [...this.localColumns, {}];
      this.updateColumns(columns);
    },

    initLocalColumns() {
      this.localColumns = this.columns;
    },

    updateColumns(value) {
      this.localColumns = value;
    },

    onColumnSelect(column, index, handleColumnSelect) {
      if (isProductOption(column)) {
        this.$emit('fetch-resources', column.type);
      }

      handleColumnSelect(column, index);
    },

    handleResourceSelectorColumnSelect(model, index, propName, prop, handleColumnSelect) {
      const column = _objectSpread({}, model[index], {
        [propName]: prop
      });

      handleColumnSelect(column, index);
    },

    isProductOption,

    factSelectorPropsForColumn(model, index) {
      const column = model[index];
      const options = getFactOptionsForType(column.type);
      const disabled = !this.resourceSelectorPropsForColumn(model, index).value;
      return {
        disabled,
        value: options.find(option => option.fact === column.fact),
        options
      };
    },

    pollSelectorPropsForColumn(model, index) {
      const column = model[index];
      const resources = this.polls;
      const selectedGuide = resources.find(guide => guide.guideId === column.guideId);

      if (!selectedGuide) {
        return {
          options: [],
          value: null,
          disabled: true
        };
      }

      const options = selectedGuide.polls;
      const value = options.find(question => question.id === column.pollId);
      return {
        disabled: false,
        options,
        value
      };
    },

    resourceSelectorPropsForColumn(model, index) {
      const column = model[index];
      const type = column.type === 'poll' ? 'guide' : column.type;
      const field = `${type}Id`;
      const options = this[`${column.type}s`];
      const placeholder = `Select ${startCase(column.type)}`;
      const value = options.find(option => option[field] === column[field]);
      return {
        placeholder,
        column,
        field,
        options,
        value
      };
    },

    onConfirm() {
      const formattedColumnsForTable = this.selectedColumns.reduce((acc, column) => {
        if (!Object.keys(column).length || column.immutable) {
          return acc;
        }

        let label = column.name;
        let fact;

        if (isProductOption(column)) {
          const type = column.type === 'poll' ? 'guide' : column.type;
          const field = `${type}Id`;

          if (!column[field]) {
            return acc;
          }

          const resource = this[`${type}s`].find(resource => resource[field] === column[field]);

          if (column.fact) {
            fact = getFactOptionsForType(column.type).find(fact => fact.fact === column.fact);
            label = `${fact.label} for ${startCase(`${column.type} ${resource.name}`)}`;
          } else if (column.pollId) {
            const selectedPoll = resource.polls.find(question => question.id === column.pollId);
            column.poll = selectedPoll;
            label = `Poll Response for ${startCase(`${resource.name}`)} - ${selectedPoll.question}`;
          }
        }

        acc.push(_objectSpread({}, column, {
          prop: column.id,
          kind: column.kind,
          schema: column.schema,
          field: column.field,
          label,
          sortable: true
        }));
        return acc;
      }, []);
      this.$emit('confirm', formattedColumnsForTable);
    }

  }
};

const __vue_script__$1 = script$1;

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('pendo-modal', {
    attrs: {
      "title": "Manage Columns",
      "height": "auto",
      "max-height": "85%",
      "append-to-body": "",
      "visible": _vm.visible
    },
    on: {
      "open": _vm.initLocalColumns,
      "close": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "pendo-column-chooser__description"
  }, [_vm._v("\n        Add, reorder or remove columns to customize your table.\n    ")]), _vm._v(" "), _c('pendo-column-reorder', {
    attrs: {
      "value": _vm.selectedColumns,
      "available-columns": _vm.availableColumns,
      "disabled": _vm.isLoadingMetadata,
      "value-key": "id",
      "label-key": "name",
      "add-button-label": "Add Column"
    },
    on: {
      "columns-change": _vm.updateColumns
    },
    scopedSlots: _vm._u([{
      key: "multiselect",
      fn: function (ref) {
        var model = ref.model;
        var index = ref.index;
        var handleColumnSelect = ref.handleColumnSelect;
        return [_c('pendo-multiselect', {
          attrs: {
            "value": model,
            "multiple": "",
            "placeholder": model[index].name || 'Select Column',
            "full-width": "",
            "max-trigger-width": 286,
            "max-menu-width": 286,
            "options": _vm.availableOptions,
            "show-selected-values": false,
            "value-key": "id",
            "label-key": "name",
            "sort-by": "name",
            "disabled": model[index].immutable
          },
          on: {
            "select": function ($event) {
              return _vm.onColumnSelect($event, index, handleColumnSelect);
            }
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function (ref) {
              var option = ref.option;
              return [_c('pendo-icon-option', {
                attrs: {
                  "option": option
                }
              })];
            }
          }, {
            key: "selectedLabel",
            fn: function () {
              return [model[index].name ? _c('pendo-icon-option', {
                attrs: {
                  "option": model[index]
                }
              }) : _vm._e()];
            },
            proxy: true
          }], null, true)
        }), _vm._v(" "), _vm.isProductOption(model[index]) ? [_c('resource-selector', _vm._b({
          attrs: {
            "loading": _vm.isLoadingResources
          },
          on: {
            "select": function ($event) {
              return handleColumnSelect($event, index);
            }
          }
        }, 'resource-selector', _vm.resourceSelectorPropsForColumn(model, index), false)), _vm._v(" "), model[index].type !== 'poll' ? [_c('pendo-multiselect', _vm._b({
          staticClass: "fact-selector",
          attrs: {
            "max-trigger-width": 286,
            "max-menu-width": 286,
            "allow-empty": false,
            "value-key": "fact",
            "sort-by": "label",
            "preselect-first": "",
            "full-width": ""
          },
          on: {
            "select": function ($event) {
              return _vm.handleResourceSelectorColumnSelect(model, index, 'fact', $event.fact, handleColumnSelect);
            }
          }
        }, 'pendo-multiselect', _vm.factSelectorPropsForColumn(model, index), false))] : _vm._e(), _vm._v(" "), model[index].type === 'poll' ? [_c('pendo-multiselect', _vm._b({
          staticClass: "poll-selector",
          attrs: {
            "placeholder": "Select Poll Question",
            "max-trigger-width": 286,
            "max-menu-width": 286,
            "allow-empty": false,
            "label-key": "question",
            "sort-by": "question",
            "full-width": "",
            "preselect-first": ""
          },
          on: {
            "select": function ($event) {
              return _vm.handleResourceSelectorColumnSelect(model, index, 'pollId', $event.id, handleColumnSelect);
            }
          }
        }, 'pendo-multiselect', _vm.pollSelectorPropsForColumn(model, index), false))] : _vm._e()] : _vm._e()];
      }
    }, {
      key: "add-button",
      fn: function () {
        return [_c('div', {
          staticClass: "report-column-editor__add-button"
        }, [_c('div', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: {
              content: _vm.disableAddColumn ? _vm.allSelectedText : null,
              arrow: true
            },
            expression: "{ content: disableAddColumn ? allSelectedText : null, arrow: true }"
          }],
          staticClass: "pendo-column-chooser__add-column",
          class: {
            'is-disabled': _vm.disableAddColumn
          },
          on: {
            "click": _vm.addColumn
          }
        }, [_c('pendo-icon', {
          attrs: {
            "type": "plus",
            "size": "16"
          }
        }), _vm._v("\n                    " + _vm._s(_vm.addButtonLabel) + "\n                ")], 1)])];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "pendo-resource-column-chooser__footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('pendo-button', {
    attrs: {
      "theme": "app",
      "type": "secondary",
      "size": "medium",
      "label": "Cancel"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }), _vm._v(" "), _c('pendo-button', {
    attrs: {
      "theme": "app",
      "type": "primary",
      "size": "medium",
      "label": "Save",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.onConfirm
    }
  })], 1)], 1);
};

var __vue_staticRenderFns__$1 = [];
const __vue_inject_styles__$1 = undefined;
const __vue_scope_id__$1 = undefined;
const __vue_is_functional_template__$1 = false;

function __vue_normalize__$1(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-resource-column-chooser.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoResourceColumnChooser = __vue_normalize__$1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1);

export default PendoResourceColumnChooser;
